module.exports = __webpack_public_path__ + "img/opet-infographic-02.8268a9d3.jpg";